export const USER_ROLES = {
    SuperAdmin: "Super Admin",
    Admin: "Admin",
    Collaborator: "Collaborator",
    Creator: "Creator",
    Editor: "Editor",
    ExternalReviewer: "External Reviewer",
    InternalReviewer: "Internal Reviewer",
} as const;

export type UserRoles = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const DEFAULT_USER = "User";

export const USER_ACTIONS = {
    canRemoveUser: "canRemoveUsers",
    canManageUsers: "canManageUsers",
    canListRoles: "canListRoles",
    canManageRoles: "canManageRoles",
    canListAllClients: "canListAllClients",
    canAddClient: "canAddClient",
    canEditClient: "canEditClient",
    canRemoveClient: "canRemoveClient",
    canListMediaItems: "canListMediaItems",
    canManageMediaItems: "canManageMediaItems",
    canListMasterTemplates: "canListMasterTemplates",
    canManageMasterTemplates: "canManageMasterTemplates",
    canAddCampaign: "canAddCampaign",
    canEditCampaign: "canEditCampaign",
    canRemoveCampaign: "canRemoveCampaign",
    canListGroupValue: "canListGroupValue",
    canManageGroupValue: "canManageGroupValue",
    canListOverwrites: "canListOverwrites",
    canManageOverwrites: "canManageOverwrites",
    canManageRestrictedEditables: "canManageRestrictedEditables",
    canPreviewDeliverable: "canPreviewDeliverable",
    canShareDeliverable: "canShareDeliverable",
    canPublishDeliverableToAdServer: "canPublishDeliverableToAdServer",
    canDownloadDeliverable: "canDownloadDeliverable",
    canChangeDeliverableVisibility: "canChangeDeliverableVisibility",
    canChangeDeliverableReportingLabel: "canChangeDeliverableReportingLabel",
    canChangeDeliverableQAStatus: "canChangeDeliverableQAStatus",
    canChangeDeliverablePublishedStatus: "canChangeDeliverablePublishedStatus",
    canListInternalAnnotations: "canListInternalAnnotations",
    canManageInternalAnnotations: "canManageInternalAnnotations",
    canListInternalComments: "canListInternalComments",
    canManageInternalComments: "canManageInternalComments",
    canListExternalAnnotations: "canListExternalAnnotations",
    canManageExternalAnnotations: "canManageExternalAnnotations",
    canListExternalComments: "canListExternalComments",
    canManageExternalComments: "canManageExternalComments",
    canManageMetadata: "canManageMetadata",
    canManageOtherUsersAnnotations: "canManageOtherUsersAnnotations",
    canManageOtherUsersComments: "canManageOtherUsersComments",
    canManageJobs: "canManageJobs",
    canListJobs: "canListJobs",
    canReceiveAllNotifications: "canReceiveAllNotifications",
    canDownloadVideo: "canDownloadVideo",
    canRetrieveReports: "canRetrieveReports",
    canManageCampaignSections: "canManageCampaignSections",
    canListFonts: "canListFonts",
    canManageFonts: "canManageFonts",
    canEnableImageProcessing: "canEnableImageProcessing",
    canUseSandbox: "canUseSandbox",
    canEnableConnectModule: "canEnableConnectModule",
    canPublishChoreographFeed: "canPublishChoreographFeed",
    canSetCampaignOMSChannel: "canSetCampaignOMSChannel",
} as const;

export type UserActions = (typeof USER_ACTIONS)[keyof typeof USER_ACTIONS];

export const USER_ACTIONS_TO_AUTHORIZE_BY_SCOPE: readonly UserActions[] = [
    USER_ACTIONS.canEditClient,
    USER_ACTIONS.canRemoveClient,
    USER_ACTIONS.canAddCampaign,
    USER_ACTIONS.canEditCampaign,
    USER_ACTIONS.canRemoveCampaign,
    USER_ACTIONS.canListMasterTemplates,
    USER_ACTIONS.canManageMasterTemplates,
    USER_ACTIONS.canListGroupValue,
    USER_ACTIONS.canManageGroupValue,
    USER_ACTIONS.canListOverwrites,
    USER_ACTIONS.canManageOverwrites,
    USER_ACTIONS.canManageRestrictedEditables,
    USER_ACTIONS.canPreviewDeliverable,
    USER_ACTIONS.canShareDeliverable,
    USER_ACTIONS.canPublishDeliverableToAdServer,
    USER_ACTIONS.canDownloadDeliverable,
    USER_ACTIONS.canDownloadVideo,
    USER_ACTIONS.canChangeDeliverableVisibility,
    USER_ACTIONS.canChangeDeliverableReportingLabel,
    USER_ACTIONS.canChangeDeliverableQAStatus,
    USER_ACTIONS.canManageInternalAnnotations,
    USER_ACTIONS.canManageExternalAnnotations,
    USER_ACTIONS.canManageInternalComments,
    USER_ACTIONS.canManageExternalComments,
    USER_ACTIONS.canManageMetadata,
    USER_ACTIONS.canManageCampaignSections,
    USER_ACTIONS.canListFonts,
    USER_ACTIONS.canManageFonts,
    USER_ACTIONS.canRetrieveReports,
];
